import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { ReactivateSubscriptionRequest } from '$/requests/ReactivateSubscription.ts';
import { queryClient } from '@/main.tsx';

const useReactivateSubscription = () => {
  const client = supabaseClient;

  const mutationFn = async (request: ReactivateSubscriptionRequest) => {
    return reactivateSubscription(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

export default useReactivateSubscription;

async function reactivateSubscription(
  client: SupabaseClient,
  request: ReactivateSubscriptionRequest
): Promise<BackendSuccessResponse<null>> {
  const { data, error } = await client.functions.invoke('reactivate_subscription', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
